import { render, staticRenderFns } from "./ServiceCardItem.vue?vue&type=template&id=8b32b6fc&scoped=true&"
import script from "./ServiceCardItem.vue?vue&type=script&lang=js&"
export * from "./ServiceCardItem.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCardItem.vue?vue&type=style&index=0&id=8b32b6fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b32b6fc",
  null
  
)

export default component.exports